
  import { css } from 'lit';
  export const styles = css`:host{color:var(--content-text-color)}`;
  